<template>
  <VForm
    v-model="filterData"
    class="form-filter"
    ref="filterData"
    @request="filterSubmit"
  >

    <div class="grid-filter mb-30">
      <VSelect
        label="Материалы:"
        name="materials"
        :options="filterOptions.materials"
        :item-text="null"
        multiple
        searchable
      />

      <VSelect
        label="Диаметры:"
        name="d_wires"
        :item-text="null"
        :options="filterOptions.d_wires"
        multiple
        searchable
      />
    </div>

    <div class="buttons button-group">
      <VButton text="Применить" type="submit" :class="{ 'btn--100': isMobile }" color="primary" />

      <VButton text="Сбросить" :class="{ 'btn--100': isMobile }" @click.native="onClickResetBtn" />
    </div>
  </VForm>
</template>

<script>
import VForm from '@/components/Form/VForm.vue'
import VSelect from '@/components/Form/VSelect.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import VButton from '@/components/simple/button/VButton.vue'

export default {
  name: 'CertificatesFilter',
  components: { VButton, VSelect, VForm },

  data () {
    return {
      filterData: {
        d_wires: null,
        materials: null
      }
    }
  },

  computed: {
    ...mapGetters('warehouse', {
      filterOptions: 'certificates/filterOptions',
      savedFilter: 'certificates/filter'
    }),
    ...mapState('mobile', {
      isMobile: 'isMobile'
    })
  },
  mounted () {
    if (this.savedFilter) {
      this.filterData.d_wires = this.savedFilter.d_wires || null
      this.filterData.materials = this.savedFilter.materials || null
    }
  },

  methods: {
    ...mapMutations('warehouse', {
      SET_FILTER: 'certificates/SET_FILTER',
      RESET_FILTER: 'certificates/RESET_FILTER'
    }),

    async filterSubmit (data) {
      this.SET_FILTER(data)
      this.$emit('closeModal')
      this.$emit('loadList')
    },

    async onClickResetBtn () {
      this.filterData.materials = null
      this.filterData.d_wires = null
      this.RESET_FILTER()
      this.$emit('closeModal')
      this.$emit('loadList')
    }
  }
}
</script>
